import { useFormContext, Controller } from "react-hook-form";
import { makeStyles, TextField } from "@material-ui/core";
import { ErrorMessage } from "@hookform/error-message";
import useFormPersist from "react-hook-form-persist";
import NumberFormat from "react-number-format";

import { IProps } from "../../types/types";
import styles from "../../styles/NumberField.module.scss";
import { useStorage } from "hooks/useStorage";

const numberFieldStyles = makeStyles(() => ({
  root: {
    "& .MuiFormLabel-root": {
      fontSize: "1.4rem",
      lineHeight: "0",
      fontFamily: "Montserrat",
      fontWeight: 500,
    },
    "& .MuiInputBase-input": { fontSize: "1.5rem" },
  },
}));

export const NumberField = ({ label, name, required, component, id }: IProps) => {
  const { storageValue } = useStorage(id);
  const {
    register,
    trigger,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  useFormPersist("onboarding", { watch, setValue, storage: window.localStorage });

  const stylesMui = numberFieldStyles();
  const errorMessage = required && "Este campo debe ser completado";

  return (
    <div className={styles.formItem}>
      <div className={styles.form}>
        <Controller
          control={control}
          {...register(component.name, {
            required: errorMessage,
          })}
          name={component.name}
          defaultValue=""
          render={({ field: { onChange, name, value, ref } }) => (
            <NumberFormat
              ref={ref}
              id={name}
              label={label}
              className={stylesMui.root}
              thousandSeparator={true}
              name={name}
              value={ !!value ? value : storageValue }
              required={required}
              onChange={onChange}
              placeholder=""
              autoComplete="off"
              customInput={TextField}
              variant="standard"
              onKeyUp={() => {
                trigger(name);
              }}
            />
          )}
        />
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <span className={styles.form__error}>{message}</span>
          )}
        />
      </div>
    </div>
  );
};
